import React from 'react';

// Only bold markers are supported. Source text is never interpreted as HTML.
export default function WorkbookExplanation({ text }: { text: string }) {
  return <section lang="id" aria-label="Pembahasan" className="mt-4 rounded-xl bg-indigo-50 p-4 text-sm leading-7 text-slate-800">
    <h3 className="mb-2 font-bold text-indigo-950">Pembahasan</h3>
    {text.split('\n').map((line, i) => <p key={i} className="whitespace-pre-wrap">
      {line.split(/(\*\*[^*]+\*\*)/g).map((part, j) => part.startsWith('**') && part.endsWith('**')
        ? <strong key={j} className="font-bold text-indigo-950">{part.slice(2, -2)}</strong> : part)}
    </p>)}
  </section>;
}
